import React from 'react'
import {Box, Divider, IconButton, List, Tooltip} from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import {NEUTRAL_SCALE, SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED} from 'src/theme-new/tokens'
import BrandHeader from './BrandHeader'
import NavItem from './NavItem'
import {NavItemConfig} from './types'

interface SideNavProps {
  expanded: boolean
  onToggle: () => void
  onNavClick?: () => void
  navItems: NavItemConfig[]
}

const SideNav = ({expanded, onToggle, onNavClick, navItems}: SideNavProps): JSX.Element => {
  const width = expanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED

  return (
    <Box
      component="nav"
      sx={{
        width,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        borderRight: `1px solid ${NEUTRAL_SCALE[200]}`,
        transition: 'width 0.2s ease',
        overflowX: 'hidden',
        overflowY: 'auto',
        flexShrink: 0,
      }}
    >
      <BrandHeader expanded={expanded} />
      <Divider />
      <List sx={{px: 1, py: 1, flexGrow: 1, overflowY: 'auto'}}>
        {navItems.map(item => (
          <NavItem key={item.key} item={item} expanded={expanded} onClick={onNavClick} />
        ))}
      </List>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: expanded ? 'flex-start' : 'center',
          px: expanded ? 2 : 0,
          py: 0,
          minHeight: 72,
        }}
      >
        <Tooltip title={expanded ? '' : 'Apri menu'} placement="right">
          <IconButton
            onClick={onToggle}
            size="small"
            aria-label={expanded ? 'Chiudi menu' : 'Apri menu'}
            sx={expanded
              ? {gap: 0.5, fontSize: 13, borderRadius: 1, width: '100%', justifyContent: 'flex-start'}
              : {borderRadius: 1}
            }
          >
            {expanded ? (
              <>
                <ChevronLeftIcon fontSize="small" />
                <Box component="span" sx={{fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap'}}>
                  Chiudi menu
                </Box>
              </>
            ) : (
              <ChevronRightIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default SideNav
